import { AxiosError } from 'axios';

interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  errors?: Record<string, string[]>;
}

export function getErrorMessage(error: unknown, fallback = 'An unexpected error occurred'): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as ProblemDetails | undefined;

    if (data?.errors) {
      return Object.entries(data.errors)
        .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
        .join('\n');
    }

    if (data?.detail) return data.detail;
    if (data?.title) return data.title;

    switch (error.response?.status) {
      case 400: return 'Invalid request. Please check your input.';
      case 401: return 'Session expired. Please log in again.';
      case 403: return 'You do not have permission to perform this action.';
      case 404: return 'The requested resource was not found.';
      case 409: return 'Conflict - this data has been modified by another user.';
      case 429: return 'Too many requests. Please wait and try again.';
      default: break;
    }

    if (error.code === 'ERR_NETWORK') return 'Network error. Please check your connection.';
    if (error.code === 'ECONNABORTED') return 'Request timed out. Please try again.';
  }

  if (error instanceof Error) return error.message;
  return fallback;
}
